// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2hwnB","onScreen":"style_onScreen__1pUQP"};